import { Phone } from "lucide-react";
import { motion } from "framer-motion";

const CallFAB = () => {
  return (
    <motion.a
      href="tel:+14794649398"
     
      className="fixed bottom-6 right-6 z-50 bg-primary hover:bg-primary/90 text-primary-foreground p-4 rounded-full shadow-lg hover:shadow-glow transition-all duration-300"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      aria-label="Call us now"
    >
      <Phone className="h-6 w-6" />
      <span className="sr-only">Call 479-464-9398</span>
    </motion.a>
  );
};

export default CallFAB;
